import { Component, Input } from '@angular/core';

@Component({
    selector: 'panel-cards',
    templateUrl: './panel.component.html',
    styleUrls: ['./panel.component.scss'],
})
export class PanelCardsComponent {
    @Input() items;
    newItem: string;
    newItemWished: string;

    constructor() {}

    addTraining() {
        let item = this.newItem;

        if (item.length > 0) {
            return this.items.push(item);
        } else {
            return;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/panel/panel.component.ts